import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { getThumbnail, isEmpty } from '../../utils/helper'
import { CustomDescriptionBox } from '../../../components'
import { AppContext } from 'src/views/context/app'
import { GlobalContext } from 'src/views/context/GlobalState'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import Loading from 'react-fullscreen-loading'

const ContentRatingModal = (props) => {
  const { openModal, onCancel, data, addCallback, updateCallback } = props
  const { loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)

  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [ratingImage, setRatingImage] = useState('')
  const [imageData, setImageData] = useState()

  const [errorData, setErrorData] = useState({})

  const editFlag = !isEmpty(data)

  useEffect(() => {
    const ratingImg = [
      {
        title: 'Rating Image',
        id: 'Rating',
        width: 50,
        height: 50,
        assetId: '',
        divheight: '9rem',
        divwidth: '9rem',
        setAssetId: (id) => {
          setRatingImage(id)
        },
        setImage: () => {},
        onRemoveImg: () => {},
        imageUrl: '',
      },
    ]
    if (!isEmpty(data)) {
      setName(data.name)
      setDescription(data.description)
      setRatingImage(data?.icon?._id)
      ratingImg[0]['assetId'] = data?.icon?._id
      ratingImg[0]['imageUrl'] = getThumbnail(
        userSessionObj.session_data.cf_domain_name,
        data?.icon?.s3_key,
      )
    }
    setImageData(ratingImg)
  }, [])

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (name.trim().length === 0) {
      isFormValid = false
      temp.name = 'Name Cannot be Empty!'
    }
    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return
    let payload = {
      name: name,
      description: description,
      icon: ratingImage,
    }

    editFlag ? updateCallback(payload, data._id) : addCallback(payload)
  }
  return (
    <>
      <CModal size="lg" visible={openModal} alignment="center">
        <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
        <CModalHeader className="px-5 py-4">
          <CModalTitle>
            {!editFlag ? `Add` : `Edit`} {`Censorship Rating`}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CustomDescriptionBox
                title="Name*"
                limit={10}
                isMandatory={true}
                errorText={errorData.name}
                rows={1}
                value={name}
                onChange={setName}
                useFormInput={true}
              />
            </CCol>
            <CCol>
              <CustomDescriptionBox
                title="Description"
                rows={1}
                value={description}
                onChange={setDescription}
                useFormInput={true}
              />
            </CCol>
          </CRow>
          <CRow className="mt-1">{imageData && <ImageUploader data={imageData} />}</CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleSave}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ContentRatingModal
